import Vue from "vue";
import Router from "vue-router";
import store from "./store";

import { BehaviorSubject, of, from } from "rxjs";
import { switchMap, tap, map, mergeMap, retry, filter } from "rxjs/operators";

import Index from "./views/Index.vue";
import Project from "./views/Project.vue";
import ProjectDetail from "./views/ProjectDetail.vue";
import Member from "./views/Member.vue";
import Shop from "./views/Shop.vue";
import About from "./views/About.vue";
import Building from "./views/Building.vue";
import Design from "./views/Design.vue";
import Join from "./views/Join.vue";
import Luckdraw from "./views/Luckdraw.vue";
import { appService } from "./services/app.service";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/Index",
      name: "Index",
      component: Index,
    },
    {
      path: "/Project/:type",
      name: "Project",
      component: Project,
    },
    {
      path: "/ProjectDetail/:type/:id",
      name: "ProjectDetail",
      component: ProjectDetail,
    },
    {
      path: "/Member",
      name: "Member",
      component: Member,
    },
    {
      path: "/Shop",
      name: "Shop",
      component: Shop,
    },
    {
      path: "/About/:position",
      name: "About",
      component: About,
    },
    {
      path: "/About",
      name: "About",
      component: About,
    },
    {
      path: "/Building",
      name: "Building",
      component: Building,
    },
    {
      path: "/Design",
      name: "Design",
      component: Design,
    },
    {
      path: "/Join",
      name: "Join",
      component: Join,
    },
    {
      path: "/Luckdraw",
      name: "Luckdraw",
      component: Luckdraw,
      meta: { auth: 1 },
    },
    {
      path: "*",
      redirect: "/Index",
    },
  ],
});

router.beforeEach(function(to, from, next) {
  if (location.hostname == "localhost" || location.hostname.indexOf('192.168') > -1) {
    appService.overall$.next(true);
  }
  if (!appService.overall$.value) {
    appService.overall$
      .pipe(
        tap((res) => {
          //
          console.log(`process.env`, process.env.NODE_ENV);
          appService.confirm$.next({ isOpen: true, type: "overall" });
        }),
        filter((res) => !!res)
      )
      .subscribe((res) => {
        document.querySelector("#app")!.scrollTop = 0;
        console.log(`complete`);
        next();
      });
    return;
  }

  if (to.meta && to.meta.auth == 1 && !appService.auth$.value) {
    appService.auth$
      .pipe(
        tap((res) => {
          //
          appService.confirm$.next({ isOpen: true, type: "auth" });
        }),
        filter((res) => !!res)
      )
      .subscribe((res) => {
        document.querySelector("#app")!.scrollTop = 0;
        console.log(`complete`);
        next();
      });
    return;
  } else {
    appService.confirm$.next({ isOpen: false, type: "" });
  }

  if (to.name == store.state.lastPage) {
    console.log(`do last`, store.state.posi);
    setTimeout(() => {
      document.querySelector("#app")!.scrollTop = store.state.posi;
    }, 10);
  } else {
    let st = document.querySelector("#app")!.scrollTop;
    store.commit("setPosi", st);
    store.commit("setLastPage", from.name);

    setTimeout(() => {
      document.querySelector("#app")!.scrollTop = 0;
    }, 10);
  }

  // ["Luckdraw"].map((n) => {
  //   console.log(n);
  //   if (n == to.name) {
  //     setTimeout(() => {
  //       document.querySelector("#app").scrollTop = 0;
  //     }, 10);
  //   }
  // });

  next();
});

router.afterEach((t, f) => {
  // if(t.meta && t.meta.auth == 1 && !appService.auth) {
  //   appService.confirm$.next({isOpen: true})
  // }
});

export default router;
